import actionTypes from './actionTypes';
import { createReducer } from '../../util/createReducer';

export type ColorMode = 'light' | 'dark';

export const COLOR_MODE_STORAGE_KEY = 'phcColorMode';

const readStoredColorMode = (): ColorMode => {
  const stored = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
  return stored === 'dark' ? 'dark' : 'light';
};

export interface ColorModeState {
  mode: ColorMode;
}

const INITIAL_STATE: ColorModeState = {
  mode: readStoredColorMode(),
};

const reducer = createReducer(INITIAL_STATE, {
  [actionTypes.SET_COLOR_MODE]: (state, action) => {
    localStorage.setItem(COLOR_MODE_STORAGE_KEY, action.mode);
    return { ...state, mode: action.mode };
  },
});

export default reducer;
